import React, { useEffect, useRef, useState } from 'react'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'

const PaginationSurveyReview = ({
  prevUserId,
  setPrevUserId,
  nextUserId,
  setNextUserId,
  currentUserId,
  setCurrentUserId,
  totalAnswers,
  setTotalAnswers,
  currentPosition,
  setCurrentPosition,
  setSearchIndex,
  searchIndex,
}) => {
  const timeOutRef = useRef(null)
  const [value, setValue] = useState(currentPosition)

  useEffect(() => {
    setValue(currentPosition)
  }, [currentPosition])

  const debouncedSearch = (value) => {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current)
    }

    toastSweetAlert({
      mode: 'loading',
      message: 'Cargando respuesta, espera un momento...',
    })

    timeOutRef.current = setTimeout(() => {
      handleChange(parseInt(value))
    }, 600)
  }

  const handleChange = (valueDebounced) => {
    if (valueDebounced > totalAnswers) {
      toastSweetAlert({
        mode: 'warningToast',
        message: 'El número ingresado es mayor al total de respuestas',
      })
      return setValue(currentPosition)
    }
    if (valueDebounced < 1) {
      toastSweetAlert({
        mode: 'warningToast',
        message: 'El número ingresado debe ser mayor a 0',
      })
      return setValue(currentPosition)
    }
    setSearchIndex(parseFloat(valueDebounced))
    setValue(valueDebounced)
  }

  return (
    <>
      <div className="d-flex justify-content-center">
        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <li className={`page-item ${prevUserId ? '' : 'disabled'}`}>
              <span
                className="page-link"
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setCurrentUserId(prevUserId)
                  setCurrentPosition(parseInt(currentPosition) - 1)
                  toastSweetAlert({
                    mode: 'loading',
                    message: 'Cargando respuesta, espera un momento...',
                  })
                }}
              >
                Anterior
              </span>
            </li>
            <li className="page-item">
              <span className="page-link" disabled>
                <div>
                  <input
                    type="number"
                    value={value}
                    style={{
                      width: '50px',
                      textAlign: 'center',
                      padding: '0',
                      border: 'none',
                      backgroundColor: 'transparent',
                    }}
                    onChange={(e) => {
                      setValue(e.target.value)
                      setTimeout(() => {
                        debouncedSearch(e.target.value)
                      }, 600)
                    }}
                  />
                  <span> de </span>
                  {totalAnswers}
                </div>
              </span>
            </li>
            <li className={`page-item ${nextUserId ? '' : 'disabled'}`}>
              <span
                style={{
                  cursor: 'pointer',
                }}
                className="page-link"
                onClick={() => {
                  setCurrentUserId(nextUserId)
                  setCurrentPosition(parseInt(currentPosition) + 1)
                  toastSweetAlert({
                    mode: 'loading',
                    message: 'Cargando respuesta, espera un momento...',
                  })
                }}
              >
                Siguiente
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </>
  )
}

export default PaginationSurveyReview
